import React, { useContext } from "react";
import AppContext from "../../../context/appContext";
import "./styles/TableListFile.scss";
import TableLoading from "../../../components/TableLoading/TableLoading";
import EditIcon from "../../../components/VectorIcons/EditIcon";
import DownloadIcon from "../../../components/VectorIcons/DownloadIcon";
import DeleteIcon from "../../../components/VectorIcons/DeleteIcon";
import ListCount from "../../../components/ListCount/ListCount";
import useDownloadAttachment from "../../../hooks/useDownloadAttachment";
import { ActionsMenu } from "../../../components/ActionsMenu/ActionsMenu";

const TableListFilesResearch = (props) => {
  const {
    handleEditFile,
    data,
    loading,
    handleConfirmationDeleteFile,
    havePermission,
    projectId,
    canDelete,
    getDeleteReason,
    canDownload,
  } = props;
  const appContext = useContext(AppContext);
  const { downloadAttachment } = useDownloadAttachment();

  const returnColor = (canPerformAction) =>
    canPerformAction ? "#ec1045" : "#7f808e";

  return (
    <section id="TableListFiles">
      <div className="filesListCounter">
        <ListCount
          total={data.length}
          text={`${
            data.length > 1 ? "Anexos encontrados" : "Anexo encontrado"
          }`}
        />
      </div>

      <div className="tableContainer researchFilesTable">
        {loading ? (
          <TableLoading />
        ) : (
          data.length > 0 && (
            <>
              <div className="tableList">
                <ul className="itemsList">
                  <li className="headerList">
                    <span className="headerName">Arquivo</span>
                    <span className="headerReceivedAt">Recebido em</span>
                    <span className="headerActions" />
                  </li>

                  {data.map((file, index) => {
                    const isDeletable = canDelete?.(file.id);
                    const deleteReason = getDeleteReason?.(file.id);
                    const canDownloadThis = canDownload?.(file.id);

                    const fileToDownload = {
                      fileData: file,
                      contentId: projectId,
                      origin: "ficha-pesquisa",
                      mode: 0,
                    };

                    return (
                      <li className="groupList" key={index}>
                        {
                          <div className="listItem mainItem">
                            <span className="lightText fileName">
                              {" "}
                              {file.fileName}{" "}
                            </span>
                            <span className="lightText receivedAt">
                              {" "}
                              {appContext.convertDatePtBr(
                                file.deliveryControl?.completionDates?.received
                              )}{" "}
                            </span>

                            <div className="actions">
                              <ActionsMenu
                                menuOptions={[
                                  havePermission && {
                                    action: () => handleEditFile(file),
                                    label: "Editar",
                                    icon: <EditIcon />,
                                  },
                                  {
                                    action: () =>
                                      downloadAttachment(fileToDownload),
                                    label: "Baixar",
                                    disabled: !canDownloadThis,
                                    icon: <DownloadIcon color="#8C8EF5" />,
                                  },
                                  havePermission && {
                                    action: () =>
                                      handleConfirmationDeleteFile(file),
                                    label: "Remover",
                                    disabled: !isDeletable,
                                    tooltip:
                                      !isDeletable && deleteReason
                                        ? deleteReason
                                        : null,
                                    icon: (
                                      <DeleteIcon
                                        color={returnColor(isDeletable)}
                                      />
                                    ),
                                  },
                                ].filter(Boolean)}
                              />
                            </div>
                          </div>
                        }
                      </li>
                    );
                  })}
                </ul>
              </div>
            </>
          )
        )}
      </div>
    </section>
  );
};

export default TableListFilesResearch;
